/* eslint-disable max-len */
import moment from 'moment';
import React, { useContext, useState } from 'react';
import AnimatedButton from '../../../../../components/Animation/AnimatedButton';
import GlobalContext from '../../../../../components/Context/GloablContext';
import { useNavigate, useParams } from 'react-router-dom';
import { FormattedNumber } from '../../../../../CommonMethods/FormattedNumber';
import AnimatedList from '../../../../../components/Animation/AnimatedList';
import FormatDateString from '../../../../../CommonMethods/FromatDateString';
const TableBody = ({tableData, indexNum, setConfirmationState,email,selectedIndex, setSelectedIndex,selectedRef,handleSidePopupClick, BranchDisabled
}) => {
    /**
     * This function sets the confirmation state to activate or deactivate an item in a table.
     */
    const {id} = useParams()
    const location=useNavigate()

    const handleActivateOpen = (e) => {
        // setActivateOpen(true)
        e.preventDefault();
        setSelectedIndex(null);
        if(e.target.id === 'View') {
            setConfirmationState({item: tableData, view : true})
        } else if(e.target.id === 'Reset Password'){
            setConfirmationState({item: tableData, status: "Reset Password"})      
        }else
        {
            setConfirmationState({item: tableData, status: !tableData.status ? 'Activate' : 'Deactivate'})
        }
    }

    const handelActionButton = async(indexNum) =>{
        setSelectedIndex(indexNum)
    }

    const handleEditClick = () => {
        location(`/manage-branches/${id}*branch_users/edit-branch-user/${tableData.email_address}`)
    }

    return (
        <>
            <AnimatedList 
                cursorpointer
                id= "list-items" 
                handleClick={(e)=>{
                    if (e.target.classList.contains('prevent-click')) {
                        return;
                    } else {
                        handleSidePopupClick('View', tableData?.email_address)
                    }
                }}
                keyItem={indexNum}
                rowStatus={tableData.status}
                child={
                    <>
                        <td className={`text-start`}>{tableData.employee_number}</td>
                        <td className={``}>{tableData.first_name} {tableData.last_name}</td>
                        <td className={`text-start`}>{tableData.email_address}</td>
                        <td className={`text-start`}>{FormattedNumber(tableData.mobile_number)}</td>
                        <td className={`text-start`}>{FormatDateString(tableData.created_at)}</td>
                        <td className="px-5 py-3 table-cell">
                            <div className='flex justify-center'>
                                <div className={`w-fit rounded ${tableData.status ? 'bg-[#C5FFD5]' : 'bg-[#B3BBC1]'} flex items-center justify-center py-1 px-2.5`}>
                                    <img loading="lazy" decoding="async" src={tableData.status ? "/images/successDot.svg" : "/images/inactive-Dot.svg" } alt="icon"/>
                                    <span className="text-f7 font-normal text-[#031624] pl-1">{tableData.status ? 'Active' : 'Inactive'}</span>
                                </div>
                            </div>
                        </td>
                        
                        <td className="text-start prevent-click">
                            <div class="relative flex items-center justify-center prevent-click" data-te-dropdown-position="dropstart">
                                <button 
                                    type='button' 
                                    class="list-more-btn prevent-click " 
                                    id={tableData.email_address}
                                    onClick={() =>handelActionButton(indexNum) }
                                    data-te-dropdown-toggle-ref
                                    aria-expanded="false"
                                    data-te-ripple-init
                                    // disabled={() => handelActionButton()}
                                    data-te-ripple-color="light">
                                    <img loading="lazy" decoding="async" src="/images/listAction.svg" alt="icon" className='prevent-click'/>
                                </button>
                                {selectedIndex === indexNum && <ul ref={selectedRef} className={`list-more-optns-div ${(indexNum+2 >= 8) ? ((!BranchDisabled || !tableData.status) ? 'top3' : 'top4') : ''} [&[data-te-dropdown-show]]:block`}
                                    aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref>
                                    <li>
                                        <AnimatedButton 
                                            handleClick={()=>{handleSidePopupClick('View', tableData.email_address)}}
                                            buttonName={"View Details"}
                                            className="list-more-optns prevent-click"
                                        />
                                    </li>
                        
                                    {email!==tableData.email_address && BranchDisabled &&
                                    <>
                                    
                                        {tableData.status && <li>
                                            <AnimatedButton 
                                                handleClick={handleEditClick} 
                                                buttonName={"Edit User"}
                                                className="list-more-optns prevent-click"
                                            />
                                        </li>}
                                        <li>
                                            <AnimatedButton 
                                                handleClick={(e)=>handleActivateOpen(e)} 
                                                buttonName={!tableData.status ? "Activate" : "Deactivate"}
                                                className="list-more-optns prevent-click"/>
                                        </li>
                                        {tableData.status && <li>
                                            <AnimatedButton 
                                                handleClick={handleActivateOpen} 
                                                buttonName={"Reset Password"}
                                                className="list-more-optns prevent-click"
                                            />
                                        </li>}
                                    </>
                                    }
                        
                                </ul>}
                            
                            </div>
                        </td>
                    </>
                }
            />
            {/* activateOpen && 
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`${tableData.status ? 'Deactivate' : 'Activate'} Branch User`}
                        message = {`Are you sure you want to ${tableData.status ? 'deactivate' : 'activate'} the branch user ${tableData.first_name} ${tableData.last_name} ?`}
                        buttonName = {`${tableData.status ? 'Deactivate' : 'Activate'}`}
                        loadingActivation={activateButtonLoading}
                    />
                }
            />  
            */}
        </>
    );
}

export default TableBody;
